/** Lowercase, trim, and collapse internal whitespace so LLM variations still match. */
export function normalizeActionTitle(title: string): string {
    return title.trim().toLowerCase().replace(/\s+/g, " ");
}

/**
 * Only actions whose normalized title matches one of these are shown.
 * Everything else is silently dropped so the LLM can't produce noisy suggestions.
 */
export const ALLOWED_NEXT_STEP_TITLES = new Set([
    "create pr",
    "update pr",
    "update agents.md",
    "create skill from this session",
    "build",
]);
